import { Typography } from 'darrius';

import styles from './CleanCard.module.scss';

interface IClearCardDescription {
  description: string;
}

export function CleanCardDescription({ description }: IClearCardDescription) {
  return (
    <Typography.Text
      className={`no-margins ${styles.clear_card__item_description}`}
    >
      {`"${description}"`}
    </Typography.Text>
  );
}
